import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DividerComponent } from '../../divider/divider.component';
import { HeadlineComponent } from '../../headline/headline.component';
import { IconModule } from '../../icon/icon.module';
import { TagComponent } from '../../tag/tag.component';
import { TooltipModule } from '../../tooltip/tooltip.module';
import { SubNavComponent } from './sub-nav.component';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		IconModule,
		TooltipModule,
		HeadlineComponent,
		DividerComponent,
		TagComponent,
	],
	declarations: [SubNavComponent],
	exports: [SubNavComponent],
})
export class SubNavModule {}
